export default "__VITE_ASSET__BFrByJ3t__"